<template>
  <div id="countdown">
    <div class="countdown-inner" v-if="!hasExpired">
      <div class="date">
        <span class="number">{{ days }}</span>
        <div class="format">Days</div>
      </div>
      <div class="date">
        <span class="number">{{ hours }}</span>
        <div class="format">Hours</div>
      </div>
      <div class="date">
        <span class="number">{{ minutes }}</span>
        <div class="format">Minutes</div>
      </div>
      <div class="date">
        <span class="number">{{ seconds }}</span>
        <div class="format">Seconds</div>
      </div>
    </div>
    <div class="countdown-pleasewait" v-else>
      <span>We're just coming online, sit tight</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  data: function() {
    return {
      wordString: {},
      end: "",
      interval: "",
      days: "",
      minutes: "",
      hours: "",
      seconds: "",
      message: "",
      hasExpired: true
    }
  },

  created: function() {
    this.end = new Date(this.activeParty.start_time).getTime()
    this.now = new Date().getTime()

    if (this.end - this.now < 0) {
      this.hasExpired = true
    } else {
      this.hasExpired = false
    }
    // Tara - if you want to put this back in then add the object in this component, rather than any parent.
  },

  mounted() {
    this.timerCount(this.end)
    this.interval = setInterval(() => {
      this.timerCount()
    }, 1000)
  },

  methods: {
    timerCount: function() {
      var now = new Date().getTime()
      var passTime = this.end - now
      if (passTime < 0) {
        this.hasExpired = true
        clearInterval(this.interval)
        return
      } else {
        this.calcTime(passTime)
      }
    },
    calcTime: function(dist) {
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24))
      this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60))
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000)
    }
  },

  computed: {
    ...mapState("partyStore", ["activeParty"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$break-sml: 620px;
$break-mid: 840px;
#countdown {
  max-width: 520px;
  margin: 40px auto;
  color: black;

  @media screen and (max-width: $break-sml) {
    margin: 20px auto;
  }
  @media screen and (max-height: 720px) and (max-width: $break-mid) and (orientation: landscape) {
    margin: 10px auto;
    max-width: 420px;
  }

  .countdown-inner {
    padding: 20px 0;
    border-top: 3px solid black;
    border-bottom: 3px solid black;
    @media screen and (max-height: 720px) and (max-width: $break-mid) and (orientation: landscape) {
      min-height: unset;
      padding: 10px 0;
    }
    .date {
      display: inline-block;
      text-align: center;
      text-transform: uppercase;
      margin: 0 20px;
      font-style: italic;
      @media screen and (max-width: $break-sml) {
        margin: 0 3vw;
      }

      .number {
        font-size: 62px;
        font-weight: bold;
        @media screen and (max-width: $break-sml) {
          font-size: 13vw;
        }
        @media screen and (max-height: 720px) and (max-width: $break-mid) and (orientation: landscape) {
          font-size: 6vw;
        }
      }
    }
  }

  .countdown-pleasewait {
    padding: 20px 0;

    @media screen and (max-height: 720px) and (max-width: $break-mid) and (orientation: landscape) {
      padding: 10px 0;
    }

    span {
      font-family: Karla;
      font-weight: bold;
      font-size: 31px;
      @media screen and (max-width: $break-sml) {
        font-size: 6vw;
      }
      @media screen and (max-height: 720px) and (max-width: $break-mid) and (orientation: landscape) {
        font-size: 3vw;
      }
    }
  }
}
</style>
